import PubSub from "underpub-js";

import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
Swiper.use([ Navigation, FreeMode ]);

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

var Timeline = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-Timeline',
	};

	$.extend(true, this.options, options);

};

Timeline.prototype.init = function() {

	var self = this;

	self.$timeline = self.options.$el.find(`.${self.options.baseClass}__timeline`);
	self.$swiperWrapper = self.$timeline.find(`.swiper-wrapper`);
	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

	self.initCarousel();
	// self.initAnimateIn();
	self.setTimelineItemsHeight();

	PubSub.subscribe('Sitewide:resized', function() {
		self.setTimelineItemsHeight();
	});

};

Timeline.prototype.setTimelineItemsHeight = function() {

	const self = this;

	let maxItemHeight = 0;

	self.options.$el.find(`.${self.options.baseClass}__timelineItem`).each(function() {

		let $item = $(this);

		let copyHeight = $item.find(`.${self.options.baseClass}__timelineItem__copy`).outerHeight();
		let copyMargin = 16;
		let headingHeight = $item.find(`.${self.options.baseClass}__timelineItem__heading`).outerHeight(true);
		let dateHeight = $item.find(`.${self.options.baseClass}__timelineItem__date`).outerHeight(true);

		let itemHeight = copyHeight + copyMargin + headingHeight + dateHeight;

		if (itemHeight > maxItemHeight) {
			maxItemHeight = itemHeight;
		}

	});

	self.options.$el.find(`.${self.options.baseClass}__timelineItem`).height(maxItemHeight);

};

Timeline.prototype.initCarousel = function() {

	const self = this;

	let swiperOptions = {

		loop: true,
		allowTouchMove: false,
		slidesPerView: 'auto',
		watchSlidesProgress: true,
		centeredSlides: true,
		initialSlide: 1,
		speed: 500,

		// arrows
		navigation: {
			nextEl: self.$arrowNext[0],
			prevEl: self.$arrowPrev[0],
		},
		
	};

	// initialize swiper
	self.swiper = new Swiper(self.$timeline[0], swiperOptions);

	// set active slide copy height on init
	let $firstActiveSlideCopy = self.options.$el.find(`.swiper-slide-active .${self.options.baseClass}__timelineItem__copyWrapper`);
	gsap.set($firstActiveSlideCopy, {
		height: "auto",
		marginTop: 16,
		opacity: 1,
	});

	// swiper events
	self.swiper.on('slideChangeTransitionStart', function() {

		let currentSlideIndex = self.swiper.realIndex;

		// let $allCopy = self.options.$el.find(`.${self.options.baseClass}__timelineItem__copy`);
		// let $nextSlideCopy = self.options.$el.find(`[data-swiper-slide-index="${currentSlideIndex}"] .${self.options.baseClass}__timelineItem__copy`);
		
		let $notNextSlideCopy = self.options.$el.find(`.swiper-slide:not(.swiper-slide-active) .${self.options.baseClass}__timelineItem__copyWrapper`);
		let $nextSlideCopy = self.options.$el.find(`.swiper-slide-active .${self.options.baseClass}__timelineItem__copyWrapper`);

		// console.log('transition start');
		// console.log($nextSlide);

		gsap.timeline({
			defaults: {
				duration: 0.4
			}
		})
		.to($notNextSlideCopy, {
			height: 0,
			marginTop: "0px",
			opacity: 0,
		})
		.to($nextSlideCopy, {
			height: "auto",
			marginTop: 16,
		}, "<")
		.to($nextSlideCopy, {
			opacity: 1,
		}, ">")
		
		
	});

};

/*
Timeline.prototype.initAnimateIn = function() {

	const self = this;

	let delay = 0;
	let $animateInItems = self.options.$el.find(`.${self.options.baseClass}__timelineItem`);

	$animateInItems.each(function() {

		let $item = $(this);
		let $dotOutline = $item.find(`.${self.options.baseClass}__timelineItem__dotMarker__dotOutline`);
		let $dot = $item.find(`.${self.options.baseClass}__timelineItem__dotMarker__dot`);
		let $line = $item.find(`.${self.options.baseClass}__timelineItem__line`);
		let $date = $item.find(`.${self.options.baseClass}__timelineItem__date`);
		let $heading = $item.find(`.${self.options.baseClass}__timelineItem__heading`);
		let $copy = $item.find(`.${self.options.baseClass}__timelineItem__copy`);

		gsap.timeline({
			scrollTrigger: {
				trigger: $item,
				start: "bottom+=20px bottom",
				// markers: true,
			},
			delay: delay,
		})
		.to($dot, {
			scale: 1,
			duration: 0.5,
			ease: "back.out(3)",
		})
		.to($dotOutline, {
			scale: 1,
			duration: 0.45,
			ease: "power1.out",
		}, ">-=0.22")
		.to($line, {
			duration: 0.3,
			bottom: 0,
			ease: "power1.out",
		}, ">-=0.15")
		.to($date, {
			duration: 0.8,
			ease: "power3.out",
			y: 0,
			opacity: 1,
		}, ">-=0.05")
		.to($heading, {
			duration: 0.8,
			ease: "power3.out",
			y: 0,
			opacity: 1,
		}, ">-=0.55")
		.to($copy, {
			duration: 0.8,
			ease: "power3.out",
			y: 0,
			opacity: 1,
		}, ">-=0.55")

		// .timeScale(0.5)
		
		delay += 0.8;

	});

};
*/

export default Timeline;
